import styled from "styled-components";
import { formatBalance } from "../../utils/formatters";

const StyledBalance = styled.p`
  font-size: 1rem;
  margin: 0.25rem 0;
  color: ${({ amount }) => (amount >= 0 ? "#009045" : "#B22222")};
  text-shadow: 0 0 0.5rem #000a;
`;

export const Balance = ({ amount }) => (
  <StyledBalance amount={amount}>{formatBalance(amount)}</StyledBalance>
);
